// extracted by mini-css-extract-plugin
module.exports = {"hgroup":"Hgroup_hgroup__ldWfo","hgroup__left":"Hgroup_hgroup__left__TKwGZ","hgroup__right":"Hgroup_hgroup__right__XiMtG","hgroup__center":"Hgroup_hgroup__center__9bgep"};